export const MembershipEndpoints = {
  getMembershipData: (slug: string) => `/rest/public/v1/memberships/${slug}`
}
